/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "8edc6ceab2d8f697b6bce9537f790b0197710582";
